import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';
import _toggleGameInfo from './toggle-game-info.js';

const useToggleGameInfo = () => {
	const router = useRouter();
	const location = useLocation();
	const transformPath = useContextualPathTransformer();

	const toggleGameInfo = useCallback(
		(gameCode, listName, listGameIndex, game) => {
			_toggleGameInfo({
				router,
				location,
				gameCode,
				listName,
				listGameIndex,
				game,
				transformPath
			});
		},
		[router, location, transformPath]
	);

	return { toggleGameInfo };
};

export default useToggleGameInfo;
